import React from 'react';

import { StatsigConfigurations } from '@confluence/statsig-configurations/entry-points/StatsigConfigurations.ts';

/**
 * Provides a way to conditionally wrap content in React.StrictMode.
 * It allows for the conditional disabling of strict mode in local development environments.
 */
export const StrictMode = ({ children }: { children: React.JSX.Element }): React.JSX.Element => {
	// allow developers to disable strict mode for local development
	const isStrictModeDisabled = process.env.STRICT_MODE === 'false';

	if (isStrictModeDisabled) {
		return children;
	}

	// React.StrictMode usage is enabled via dynamic config or environment variable
	if (
		StatsigConfigurations.getBoolean('confluence_strict_mode_config', false) ||
		process.env.STRICT_MODE === 'true'
	) {
		return <React.StrictMode>{children}</React.StrictMode>;
	} else {
		return children;
	}
};
